runOnFirstInteraction(function () {
  function swymCallbackFn(swat){
    try {
      if (swat && swat.collectionsApi) {
        swat.collectionsApi.initializeCollections(
          swat,
          false,
          Shopify.theme.id
        );
      }
    } catch(e) {}
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCallbackFn);
});

window.addEventListener('load', function(){
  (function () {
    const STORAGE_KEY = 'swymWishlistCountDisplay';
    const THEME_HEX = '#a85a3b';
    const THEME_RGB = 'rgb(168, 90, 59)';

    function getHeaderLink() {
      return document.querySelector('a.header__icon[aria-label^="Wishlist"]')
          || document.querySelector('a.header__icon[title^="Wishlist"]')
          || document.querySelector('a.header__icon[href*="wishlist"]');
    }

    function ensureBadge() {
      const link = getHeaderLink();
      if (!link) return null;

      let badge = link.querySelector('.wishlist-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wishlist-count';
        badge.hidden = true;                   // zero par hidden
        badge.textContent = '0';

        // minimal fallback styling — CSS load se pehle bhi visible rahe
        if (getComputedStyle(link).position === 'static') link.style.position = 'relative';
        Object.assign(badge.style, {
          position:'absolute', top:'-6px', right:'-6px',
          minWidth:'18px', height:'18px', lineHeight:'18px',
          padding:'0 5px', borderRadius:'9px',
          fontSize:'12px', fontWeight:'600', textAlign:'center',
          background: THEME_HEX, color:'#fff', zIndex:'2', pointerEvents:'none'
        });

        link.appendChild(badge);
        link.classList.add('has-wishlist-badge');
      }
      return badge;
    }

    function storeCount(n){ try { localStorage.setItem(STORAGE_KEY, String(Math.max(0, Number(n)||0))); } catch(e){} }
    function readStoredCount(){
      try { const v = parseInt(localStorage.getItem(STORAGE_KEY)||'0', 10); return isNaN(v) ? 0 : v; }
      catch(e){ return 0; }
    }

    function drawBadge(n, {persist=true} = {}) {
      const b = ensureBadge();
      if (!b) return;
      n = Math.max(0, Number(n)||0);
      if (n > 0) { b.textContent = n > 9 ? '9+' : String(n); b.hidden = false; }
      else { b.textContent = '0'; b.hidden = true; }
      const parent = b.closest('a,button') || b;
      parent.setAttribute('aria-label', n > 0 ? `Wishlist (${n})` : 'Wishlist');
      parent.setAttribute('title',     n > 0 ? `Wishlist (${n})` : 'Wishlist');
      if (persist) storeCount(n);
    }

    function getBadgeCount() {
      const b = ensureBadge();
      if (!b || b.hidden) return 0;
      const n = parseInt((b.textContent || '0').replace('+',''), 10);
      return isNaN(n) ? 0 : n;
    }

    /* ----------------- Swym: source of truth ----------------- */
    function fetchWishlistCount() {
      if (!window._swat || !window._swat.fetchWrtEventTypeET) return;
      window._swat.fetchWrtEventTypeET({ et: 5 }, function(items) {
        drawBadge(items ? items.length : 0);
      });
    }

    function onSwymReady() {
      fetchWishlistCount();
      if (window._swat && window._swat.on) {
        try {
          window._swat.on('wishlistUpdated', fetchWishlistCount);
          window._swat.on('item-added',      fetchWishlistCount);
          window._swat.on('item-removed',    fetchWishlistCount);
        } catch(e){}
      }
    }

    /* ----------------- Detect if Swym popup just opened ----------------- */
    function detectSwymPopupOpening(callback) {
      const appearsOpen = () => {
        const el = document.querySelector(
          '.swym-ui, .swym-modal, .swym-wishlist-modal, .swym-overlay, [role="dialog"][class*="swym"]'
        );
        return !!(el && getComputedStyle(el).display !== 'none' && el.offsetParent !== null);
      };
      if (appearsOpen()) { callback(true); return; }

      let opened = false;
      const obs = new MutationObserver(() => {
        if (appearsOpen()) { opened = true; obs.disconnect(); callback(true); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });

      // 400ms window: if nothing appears, assume no popup
      setTimeout(() => { if (!opened) { obs.disconnect(); callback(false); } }, 400);
    }

    /* ----------------- Helpers to avoid false-positives ----------------- */
    function classString(el){
      if (!el) return '';
      const c = el.className;
      return typeof c === 'string' ? c : (c && c.baseVal) ? c.baseVal : '';
    }

    function isCloseControl(target) {
      const node = (target.closest && target.closest('button, a, [role="button"], svg')) || target;
      if (!node) return false;

      const ariaHiddenTrue = node.closest('[aria-hidden="true"]');
      if (ariaHiddenTrue && node.closest('svg')) return true; // hidden SVGs

      const label = (node.getAttribute && (node.getAttribute('aria-label') || node.getAttribute('title'))) || '';
      const titleEl = node.querySelector && node.querySelector('title');
      const titleTxt = titleEl ? (titleEl.textContent || '') : '';
      const idTxt = (node.id || '');
      const cls = classString(node);

      const haystack = [label, titleTxt, idTxt, cls].join(' ').toLowerCase();

      // common "close" keywords & klaviyo classes
      if (/(^|\s)(close|dismiss|cancel|cross|x)(\s|$)/i.test(haystack)) return true;
      if (/klaviyo/.test(haystack) && /close/.test(haystack)) return true;
      if (/title-?close-?dialog/i.test(haystack)) return true;

      return false;
    }

    function attrColor(el, attr) {
      const v = (el.getAttribute && el.getAttribute(attr)) || '';
      return (v || '').trim().toLowerCase();
    }

    function isThemeColor(val) {
      if (!val) return false;
      const v = val.replace(/\s+/g,'').toLowerCase();
      return v.includes(THEME_HEX) || v.includes(THEME_RGB);
    }

    function svgLooksLikeHeart(svg) {
      // Heuristic: treat as our heart only if path uses theme color
      const path = svg && svg.querySelector && svg.querySelector('path');
      if (!path) return false;
      const stroke = attrColor(path, 'stroke');
      const fill   = attrColor(path, 'fill');
      const cssColor = getComputedStyle(svg).color.toLowerCase();
      return isThemeColor(stroke) || isThemeColor(fill) || isThemeColor(cssColor);
    }

    /* ----------------- Identify inline SVG heart (outline/filled) ----------------- */
    function classifyInlineSvgHeart(el) {
      const svg = el.closest && el.closest('svg');
      if (!svg) return null;

      // Ignore header icon
      const header = getHeaderLink();
      if (header && header.contains(svg)) return null;

      // Ignore explicit close controls
      if (isCloseControl(svg)) return null;

      // Only treat as heart if it uses our theme color
      if (!svgLooksLikeHeart(svg)) return null;

      const path = svg.querySelector('path');
      if (!path) return null;

      const fill = (attrColor(path, 'fill') || '');
      // outline heart => ADD, filled heart => REMOVE
      if (fill === '' || fill === 'none' || fill === 'transparent') return 'add';
      return 'remove';
    }

    /* ----------------- Click handling ----------------- */
    document.addEventListener('click', function(e){
      // 0) Global guard: ignore any Close/Dismiss/Cross clicks
      if (isCloseControl(e.target)) return;

      const headerLink = getHeaderLink();
      if (headerLink && e.target && headerLink.contains(e.target)) {
        return; // header -> navigation only
      }

      /* 1) PDP button (#swym-vs-add-to-wishlist-single) */
      const pdpBtn = e.target.closest && e.target.closest('#swym-vs-add-to-wishlist-single.swym-add-to-wishlist-single');
      if (pdpBtn) {
        const text      = (pdpBtn.textContent || '').trim().toLowerCase();
        const inListCls = pdpBtn.classList.contains('variant-in-wishlist');
        const isRemove  = inListCls || /remove\s*from\s*list/i.test(text);
        const isAdd     = !inListCls && /add\s*to\s*list/i.test(text);
        if (isAdd)    drawBadge(getBadgeCount() + 1);
        if (isRemove) drawBadge(Math.max(0, getBadgeCount() - 1));
        return;
      }

      /* 2) Collections heart button (.swym-wishlist-collections-v2) with popup gating */
      const colBtn = e.target.closest && e.target.closest('button.swym-wishlist-collections-v2');
      if (colBtn) {
        const pressed = String(colBtn.getAttribute('aria-pressed')).toLowerCase() === 'true';
        const deltaIfNoPopup = pressed ? -1 : +1;

        const al = (colBtn.getAttribute('aria-label') || '').toLowerCase();
        const likelyOpener = /view\s*wishlist/.test(al) || /open/.test(al);

        detectSwymPopupOpening(function(opened){
          if (!opened && !likelyOpener) {
            drawBadge(Math.max(0, getBadgeCount() + deltaIfNoPopup));
          }
        });
        return;
      }

      /* 3) Raw inline SVG hearts (theme-colored) with popup gating */
      const classification = classifyInlineSvgHeart(e.target);
      if (classification === 'add' || classification === 'remove') {
        const delta = classification === 'add' ? +1 : -1;
        // Agar click se popup open ho raha hai -> NO counter change
        detectSwymPopupOpening(function(opened){
          if (!opened) {
            drawBadge(Math.max(0, getBadgeCount() + delta));
          }
        });
        return;
      }

      /* 4) Generic Swym add triggers (excluding collections button) */
      const addBtn = e.target.closest &&
        e.target.closest('[data-swaction="addToWishlist"], .swym-add-to-wishlist-single');
      if (addBtn && !addBtn.closest('.swym-wishlist-collections-v2')) {
        drawBadge(getBadgeCount() + 1);
        const svg = e.target.closest && e.target.closest('svg');
        if (svg) svg.classList.add('is-filled');
        return;
      }

      /* 5) Wishlist page remove control */
      const removeBtn = e.target.closest &&
        e.target.closest('.swym-storefront-layout-action-tooltip-btn.remove-from-list-button');
      if (removeBtn) {
        drawBadge(Math.max(0, getBadgeCount() - 1));
        return;
      }
    });

    /* ----------------- First paint ----------------- */
    document.addEventListener('DOMContentLoaded', function(){
      ensureBadge();
      const saved = readStoredCount();
      if (saved > 0) {
        drawBadge(saved, {persist:false}); // prepaint; Swym sync will correct
      }
    });

    // Swym lifecycle
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(onSwymReady);
  })();
});
